import styled from 'styled-components';
export const SIZE = {
    small: 200,
    medium: 264,
    large: 296,
};
export const Container = styled.div `
  min-width: ${({ size }) => SIZE[size]}px;
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  padding: var(--space-100);
`;
